import { apiHosts } from "@/api/constants/apiHosts";
import type { AccessRequest, AccessRequestResponse } from "@/views/accessRequest/accessRequest";
import { ToastOptionsError, ToastOptionsSuccess } from "@modernary/mui/components/toasts";
import { apiService, type PagingApiAndNotifierConfig } from "@modernary/mui/utils/api";

const URL = "access-requests";
const ENTITY_NAME = "Request";

const axiosParams = {
  // Set different base URL based on the environment
  baseURL: import.meta.env.VITE_AQMS_API_BASE_URL,
};
const api = apiService<AccessRequest>(apiHosts.AQMS, axiosParams);

const createAccessRequest = (accessRequest: AccessRequest, config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.title = "Request Submitted";
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.created = ENTITY_NAME;
    config?.errorToastCb?.(options);
  };

  return api.post(URL, accessRequest, {
    successToastCb,
    errorToastCb,
  });
};

export { createAccessRequest };
